import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncorrectPermissions = _resolveComponent("IncorrectPermissions")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_DataProportionChart = _resolveComponent("DataProportionChart")!
  const _component_BaseChart = _resolveComponent("BaseChart")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_RadialBarChart = _resolveComponent("RadialBarChart")!
  const _component_StackedPercentageChart = _resolveComponent("StackedPercentageChart")!
  const _component_MultiChart = _resolveComponent("MultiChart")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.isPermissionDenied || !_ctx.canViewRolePermission)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IncorrectPermissions)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_container, {
        key: 1,
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ValidationAlert, { "validation-results": _ctx.validationResults }, null, 8, ["validation-results"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
            : (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar, {
                    color: "secondary",
                    extended: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("Metric Report Charts", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_sheet, {
                    elevation: "8",
                    height: "100%",
                    width: "100%"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "mx-auto",
                                "max-width": "100%",
                                style: {"margin-top":"-60px","padding":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, null, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                      _createElementVNode("span", null, "Report Data Options", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_container, { fluid: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_form, {
                                            modelValue: _ctx.isValid,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isValid) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    md: "6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "font-weight-black text" }, "Select Time Period:", -1)),
                                                      _createVNode(_component_v_radio_group, {
                                                        modelValue: _ctx.windowRadio,
                                                        "onUpdate:modelValue": [
                                                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.windowRadio) = $event)),
                                                          _ctx.updateDates
                                                        ]
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_radio, {
                                                            label: "Weekly",
                                                            value: "1"
                                                          }),
                                                          _createVNode(_component_v_radio, {
                                                            label: "Monthly",
                                                            value: "2"
                                                          }),
                                                          _createVNode(_component_v_radio, {
                                                            label: "Quarterly",
                                                            value: "3"
                                                          }),
                                                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                            activator: _withCtx(({ props }) => [
                                                              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                                                _createVNode(_component_v_radio, {
                                                                  label: "Custom",
                                                                  value: "99"
                                                                })
                                                              ], 16)
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _cache[9] || (_cache[9] = _createElementVNode("span", null, "When selected, the window width will be calculated from the Start and End dates defined in the fields below.", -1))
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "4",
                                                    md: "4"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_tooltip, { bottom: "" }, {
                                                        activator: _withCtx(({ props }) => [
                                                          _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                                            _createVNode(_component_v_row, null, {
                                                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                                _createElementVNode("p", { class: "font-weight-medium text" }, " No data prior to this date will be included in the summary. ", -1)
                                                              ]))]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_row, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field, {
                                                                  modelValue: _ctx.cutoffDate,
                                                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cutoffDate) = $event)),
                                                                  label: 'Report Start Date',
                                                                  type: 'date',
                                                                  "hide-details": "",
                                                                  color: "white",
                                                                  required: ""
                                                                }, null, 8, ["modelValue"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ], 16)
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _cache[12] || (_cache[12] = _createElementVNode("span", null, "No data will be fetched for periods before this date. Setting the cutoff to a date far in the past will result in longer loading times.", -1))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                  _createElementVNode("p", { class: "font-weight-medium text" }, " The summary window can be tweaked using these dates to support a variable start date and period length. The period start date will be automatically set based on the radio button selection above. Each data point corresponds to a time period equal to the difference between the two dates below. ", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "4",
                                                    md: "3"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_tooltip, {
                                                        bottom: "",
                                                        disabled: _ctx.tooltipStartDate == ''
                                                      }, {
                                                        activator: _withCtx(({ props }) => [
                                                          _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                                            _createVNode(_component_v_text_field, {
                                                              modelValue: _ctx.startDate,
                                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event)),
                                                              label: 'Current Period Start Date',
                                                              type: 'date',
                                                              "hide-details": "",
                                                              color: "white",
                                                              required: "",
                                                              disabled: _ctx.windowRadio != _ctx.VisualizationWindowSize.Custom
                                                            }, null, 8, ["modelValue", "disabled"])
                                                          ], 16)
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_ctx.tooltipStartDate), 1)
                                                        ]),
                                                        _: 1
                                                      }, 8, ["disabled"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "4",
                                                    md: "3"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: _ctx.endDate,
                                                        "onUpdate:modelValue": [
                                                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                                                          _ctx.updateDates
                                                        ],
                                                        label: 'Report End Date',
                                                        type: 'date',
                                                        "hide-details": "",
                                                        color: "white",
                                                        required: "",
                                                        disabled: _ctx.windowRadio == _ctx.VisualizationWindowSize.Quarterly
                                                      }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "8",
                                                    md: "6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_autocomplete, {
                                                        items: _ctx.userAttachedPrograms,
                                                        "item-title": "description",
                                                        "item-value": "treatmentProgramId",
                                                        modelValue: _ctx.selectedProgram,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedProgram) = $event)),
                                                        label: "Treatment Program",
                                                        rules: _ctx.requiredFieldRules
                                                      }, null, 8, ["items", "modelValue", "rules"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              (!_ctx.isLoading)
                                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { align: "center" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                            activator: _withCtx(({ props }) => [
                                                              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                                  color: "info",
                                                                  onClick: _ctx.loadVizData,
                                                                  disabled: !_ctx.isValid
                                                                }, {
                                                                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                    _createTextVNode("Get Data", -1)
                                                                  ]))]),
                                                                  _: 1
                                                                }, 8, ["onClick", "disabled"])), [
                                                                  [_directive_ripple]
                                                                ])
                                                              ], 16)
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _createElementVNode("span", null, _toDisplayString(_ctx.tooltipGetData), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    align: "center",
                                                    class: "centered-column"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", null, [
                                                        (_ctx.isLoadingViz)
                                                          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              (_ctx.isLoadingViz)
                                                ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "12",
                                                        align: "center",
                                                        class: "centered-column"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.longLoadExpected)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [...(_cache[15] || (_cache[15] = [
                                                                _createElementVNode("p", { class: "font-weight-black text" }, " This may take a moment. Please do not refresh the page. ", -1)
                                                              ]))]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panels, {
                    variant: "accordion",
                    modelValue: _ctx.openPanels,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openPanels) = $event)),
                    disabled: _ctx.charts == null,
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, { class: "font-weight-black" }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("Program Performance", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              (_ctx.charts != null)
                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programPerformanceCharts, (chart) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "6",
                                          xl: "4",
                                          key: chart.chartTitle!
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, { elevation: "1" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(chart.chartTitle), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                (chart.chartType == 'data-proportional')
                                                  ? (_openBlock(), _createBlock(_component_DataProportionChart, _mergeProps({
                                                      key: 0,
                                                      ref_for: true
                                                    }, chart), null, 16))
                                                  : (chart.chartType == 'multi-line')
                                                    ? (_openBlock(), _createBlock(_component_BaseChart, {
                                                        key: 1,
                                                        chartData: chart.charts,
                                                        chartOptions: chart.chartOptions
                                                      }, null, 8, ["chartData", "chartOptions"]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, { class: "font-weight-black" }, {
                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                              _createTextVNode("Drug Test Metrics", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              (_ctx.charts != null)
                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drugTestCharts, (chart) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6",
                                          xl: "4",
                                          key: chart.chartTitle!
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, { elevation: "1" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(chart.chartTitle), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                (chart.chartType == 'data-proportional')
                                                  ? (_openBlock(), _createBlock(_component_DataProportionChart, _mergeProps({
                                                      key: 0,
                                                      ref_for: true
                                                    }, chart), null, 16))
                                                  : (chart.chartType == 'radial')
                                                    ? (_openBlock(), _createBlock(_component_RadialBarChart, _mergeProps({
                                                        key: 1,
                                                        ref_for: true
                                                      }, chart), null, 16))
                                                    : (chart.chartType == 'hundred')
                                                      ? (_openBlock(), _createBlock(_component_StackedPercentageChart, _mergeProps({
                                                          key: 2,
                                                          ref_for: true
                                                        }, chart), null, 16))
                                                      : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, { class: "font-weight-black" }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode("Event Metrics", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              (_ctx.charts != null)
                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.behaviorCharts, (chart) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          cols: "12",
                                          sm: "12",
                                          md: "6",
                                          lg: "6",
                                          xl: "4",
                                          key: chart.chartTitle!
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, { elevation: "1" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(chart.chartTitle), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                (chart.chartType == 'hundred')
                                                  ? (_openBlock(), _createBlock(_component_StackedPercentageChart, _mergeProps({
                                                      key: 0,
                                                      ref_for: true
                                                    }, chart), null, 16))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, { class: "font-weight-black" }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createTextVNode("Configurable Chart", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              (_ctx.charts != null)
                                ? (_openBlock(), _createBlock(_component_MultiChart, {
                                    key: 0,
                                    chartData: _ctx.charts,
                                    chartOptions: _ctx.VisualizerOptions.getLargeOptionsWithXaxis(_ctx.xlabels)
                                  }, null, 8, ["chartData", "chartOptions"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, { class: "font-weight-black" }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                              _createTextVNode("Raw Summary Data", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              (_ctx.charts != null)
                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charts, (chart) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          cols: "12",
                                          xl: "3",
                                          lg: "4",
                                          md: "6",
                                          sm: "12",
                                          key: chart.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.camelCaseToWords(chart.name)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_BaseChart, {
                                                      chartData: [chart],
                                                      chartOptions: _ctx.VisualizerOptions.getOptionsWithXaxis(_ctx.xlabels)
                                                    }, null, 8, ["chartData", "chartOptions"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }))
}